import { gql } from "@apollo/client"
import { Company, QueryCompanyArgs } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

const QUERY = gql`
  query PayrollChangePopupGetCompanyPaymentCurrencyCode($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentCurrencyCode
    }
  }
`

export const useGetCompanyPaymentCurrencyCode = ({ companyId }: QueryCompanyArgs) => {
  const { data } = useQuery<{ company: Pick<Company, "paymentCurrencyCode"> }, QueryCompanyArgs>(
    QUERY,
    {
      variables: {
        companyId,
      },
    },
  )

  return data?.company?.paymentCurrencyCode || ""
}
